import moment from 'moment';
import empty from 'is-empty';
import {connect} from 'react-redux';
import classnames from 'classnames';
import React, {Component} from 'react';
import InputRange from 'react-input-range';
import Autocomplete from 'react-google-autocomplete';

import SearchForMap from '../SearchForMap';
import FiltersAccordItem from '../FiltersAccordItem';
import * as ObjectConst from '../../../constants/Property';
import {
    setAddress,
    setMinArea,
    setMaxArea,
    setPlaceId,
    findObjects,
    setMinPrice,
    setMaxPrice,
    setRangeArea,
    setRangePrice,
    setLifestyles,
    setPoolValues,
    setFloorValues,
    setViewsValues,
    setOurExclusive,
    setGarageValues,
    setGardenValues,
    setCountBedrooms,
    setNewTypeValues,
    setKitchenValues,
    setEasyFurniture,
    setTypeApartments,
    setCountBathrooms,
    setConditionValues,
    setIsShowAllFilters,
    setOrientationValues,
    setIsShowAdvancedSearch,
    setMinYearOfConstruction,
    setMaxYearOfConstruction,
    setRangeYearOfConstruction,
    setMapDataFromPlaceAutoComplete
} from '../../../actions/Search';

const defaultProps = {
    setAddress: address => {
    },
    setMinArea: minArea => {
    },
    setMaxArea: maxArea => {
    },
    setPlaceId: placeId => {
    },
    setLifestyles: name => {
    },
    setPoolValues: value => {
    },
    setMinPrice: minPrice => {
    },
    setMaxPrice: maxPrice => {
    },
    setFloorValues: value => {
    },
    setViewsValues: value => {
    },
    setGarageValues: value => {
    },
    setGardenValues: value => {
    },
    setRangeArea: rangeArea => {
    },
    setKitchenValues: value => {
    },
    setTypeApartments: name => {
    },
    setRangePrice: rangePrice => {
    },
    setConditionValues: value => {
    },
    findObjects: requestParams => {
    },
    setNewTypeValues: isNewType => {
    },
    setOrientationValues: value => {
    },
    setOurExclusive: isExclusive => {
    },
    setCountBedrooms: countBedrooms => {
    },
    setEasyFurniture: isEasyFurniture => {
    },
    setCountBathrooms: countBathrooms => {
    },
    setIsShowAllFilters: isShowAllFilters => {
    },
    setIsShowAdvancedSearch: isShowAdvancedSearch => {
    },
    setMinYearOfConstruction: minYearOfConstruction => {
    },
    setMaxYearOfConstruction: maxYearOfConstruction => {
    },
    setMapDataFromPlaceAutoComplete: placeAutoComplete => {
    },
    setRangeYearOfConstruction: rangeYearOfConstruction => {
    }
};

const MIN_YEAR_OF_CONSTRUCTION = 1900;
const MAX_YEAR_OF_CONSTRUCTION = parseInt(moment().format('YYYY'), 10);

class FiltersBlockVertical extends Component {
    state = {
        minArea: 0,
        maxArea: 1,
        minPrice: 0,
        maxPrice: 1,
        easyFurnitureValues: [],
        minYearOfConstruction: MIN_YEAR_OF_CONSTRUCTION,
        maxYearOfConstruction: MAX_YEAR_OF_CONSTRUCTION,
        activeAccord: '',
        rangeArea: {
            min: 0,
            max: 1
        },
        rangePrice: {
            min: 0,
            max: 1
        },
        rangeYearOfConstruction: {
            min: MIN_YEAR_OF_CONSTRUCTION,
            max: MAX_YEAR_OF_CONSTRUCTION
        }
    };

    componentDidMount() {
        this.setAddress(this.props);

        this.setState(this.getRanges(this.props));

        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillReceiveProps(nextProps) {
        this.setAddress(nextProps);
        this.setState(this.getRanges(nextProps));
        this.setEasyFurnitureValues(nextProps);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setEasyFurnitureValues = props => {
        const {
            searchPage: {
                requestParams: {
                    amenities
                }
            }
        } = props;

/*        this.setState({
            easyFurnitureValues: [amenities.includes(ObjectConst.OBJECT_REPRESENT_FIELDS.EASE_FURNITURE.value)]
        });*/
    };

    setAddress(props) {
        const {
            searchPage: {
                requestParams: {
                    address
                }
            }
        } = props;

        if (this.addressAutocomplete !== undefined && address !== undefined) {
            this.addressAutocomplete.refs.input.value = address;
        }
    };

    getRanges = props => {
        const {
            searchPage: {
                requestParams: {
                    minArea,
                    maxArea,
                    minPrice,
                    maxPrice,
                    minYearOfConstruction,
                    maxYearOfConstruction
                }
            }
        } = props;
        const newState = {};

        newState.rangeArea = {
            min: minArea === undefined ? 0 : minArea,
            max: maxArea === undefined ? 1 : maxArea
        };
        newState.rangePrice = {
            min: minPrice === undefined ? 0 : minPrice,
            max: maxPrice === undefined ? 1 : maxPrice
        };
        newState.rangeYearOfConstruction = {
            min: minYearOfConstruction === undefined ? MIN_YEAR_OF_CONSTRUCTION : minYearOfConstruction,
            max: maxYearOfConstruction === undefined ? MAX_YEAR_OF_CONSTRUCTION : maxYearOfConstruction
        };
        newState.minArea = newState.rangeArea.min;
        newState.maxArea = newState.rangeArea.max;
        newState.minPrice = newState.rangePrice.min;
        newState.maxPrice = newState.rangePrice.max;
        newState.minYearOfConstruction = newState.rangeYearOfConstruction.min;
        newState.maxYearOfConstruction = newState.rangeYearOfConstruction.max;

        return newState;
    };

    handleTypeApartmentsCheck = value => {
        this.props.setTypeApartments(value);
    };

    handleCountBedroomsCheck = value => {
        this.props.setCountBedrooms(value);
    };

    handleCountBathroomsCheck = value => {
        this.props.setCountBathrooms(value);
    };

    handleOurExclusiveCheck = event => {
        this.props.setOurExclusive(event.currentTarget.checked);
    };

    handleNewTypeCheck = event => {
        this.props.setNewTypeValues(event.currentTarget.checked);
    };

    handleFindClick(event) {
        event.preventDefault();

        const {
            findObjects,
            searchPage: {
                requestParams
            }
        } = this.props;

        findObjects(requestParams);
    }

    handleAddressChange(place) {
        this.props.setMapDataFromPlaceAutoComplete(place);
    }

    handleRangePriceChange(rangePrice) {
        this.props.setRangePrice(rangePrice);
    }

    handleRangeAreaChange(rangeArea) {
        this.props.setRangeArea(rangeArea);
    }

    handleLifeStylesCheck = value => {
        this.props.setLifestyles(value);
    };

    handlePoolValuesCheck = value => {
        this.props.setPoolValues(value);
    };

    handleGarageValuesCheck = value => {
        this.props.setGarageValues(value);
    };

    handleGardenValuesCheck = value => {
        this.props.setGardenValues(value);
    };

    handleFloorValuesCheck = value => {
        this.props.setFloorValues(value);
    };

    handleOrientationValuesCheck = value => {
        this.props.setOrientationValues(value);
    };

    handleViewsValuesCheck = value => {
        this.props.setViewsValues(value);
    };

    handleConditionValuesCheck = value => {
        this.props.setConditionValues(value);
    };

    handleKitchenValuesCheck = value => {
        this.props.setKitchenValues(value);
    };

    handleRangeYearOfConstruction = rangeYearOfConstruction => {
        this.props.setRangeYearOfConstruction(rangeYearOfConstruction);
    };

    handleEasyFurnitureValuesCheck = value => {
        this.props.setEasyFurniture(value);
    };

    handleMinMaxChange = event => {
        const newState = {};
        const value = event.target.value;
        const valueInt = parseInt(event.target.value, 10);
        const {
            setMinArea,
            setMaxArea,
            setMinPrice,
            setMaxPrice,
            setMinYearOfConstruction,
            setMaxYearOfConstruction,
            searchPage: {
                rangeAreaSettings: {
                    min: minAreaSettings,
                    max: maxAreaSettings
                },
                rangePriceSettings: {
                    min: minPriceSettings,
                    max: maxPriceSettings
                },
                requestParams: {
                    maxArea,
                    minArea,
                    maxPrice,
                    minPrice,
                    minYearOfConstruction,
                    maxYearOfConstruction
                }
            }
        } = this.props;

        switch (event.target.name) {
            case 'minArea':
                newState.minArea = value;
                if (valueInt < maxArea && valueInt >= minAreaSettings) {
                    setMinArea(valueInt);
                }
                break;
            case 'maxArea':
                newState.maxArea = value;
                if (valueInt > minArea && valueInt <= maxAreaSettings) {
                    setMaxArea(valueInt);
                }
                break;
            case 'minPrice':
                newState.minPrice = value;
                if (valueInt < maxPrice && valueInt >= minPriceSettings) {
                    setMinPrice(valueInt);
                }
                break;
            case 'maxPrice':
                newState.maxPrice = value;
                if (valueInt > minPrice && valueInt <= maxPriceSettings) {
                    setMaxPrice(valueInt);
                }
                break;
            case 'minYearOfConstruction':
                newState.minYearOfConstruction = value;
                if (valueInt < maxYearOfConstruction && valueInt >= MIN_YEAR_OF_CONSTRUCTION) {
                    setMinYearOfConstruction(valueInt);
                }
                break;
            case 'maxYearOfConstruction':
                newState.maxYearOfConstruction = value;
                if (valueInt > minYearOfConstruction && valueInt <= MAX_YEAR_OF_CONSTRUCTION) {
                    setMaxYearOfConstruction(valueInt);
                }
                break;
            default:
                break;
        }
        this.setState(newState);
    };

    toggleIsShowAllFilters = event => {
        event.preventDefault();

        const {
            setIsShowAllFilters,
            searchPage: {
                isShowAllFilters
            }
        } = this.props;

        setIsShowAllFilters(!isShowAllFilters);
    };

    toggleIsShowAdvancedSearch = () => {
        const {
            setIsShowAdvancedSearch,
            searchPage: {
                isShowAdvancedSearch
            }
        } = this.props;

        setIsShowAdvancedSearch(!isShowAdvancedSearch);
    };

    setActiveAccord = (event, activeAccord) => {
        event.preventDefault();

        this.setState(prevState => ({
            activeAccord: prevState.activeAccord === activeAccord ? '' : activeAccord
        }));
    };

    clearActiveAccord = () => {
        if (this.state.activeAccord !== '') {
            this.setState({
                activeAccord: ''
            });
        }
    };

    handleClickOutside = event => {
        if (
            this.moreFilter &&
            !this.moreFilter.contains(event.target) &&
            this.filtersAccord &&
            !this.filtersAccord.contains(event.target) &&
            this.filtersAccord2 &&
            !this.filtersAccord2.contains(event.target) &&
            this.filterRent2Cont &&
            !this.filterRent2Cont.contains(event.target)
        ) {
            this.clearActiveAccord();
        }
    };

    getEasyFurnitureValues = () => {
        const {i18n} = this.props;

        return [
            {
                title: i18n['objectPage.no'],
                value: false
            },
            {
                title: i18n['objectPage.yes'],
                value: true
            }
        ]
    };

    render() {
        const {
            i18n,
            searchPage: {
                isShowAllFilters,
                isShowAdvancedSearch,
                rangeAreaSettings: {
                    min: minAreaSettings,
                    max: maxAreaSettings
                },
                rangePriceSettings: {
                    min: minPriceSettings,
                    max: maxPriceSettings
                },
                requestParams: {
                    lifestyles,
                    poolValues,
                    floorValues,
                    viewsValues,
                    garageValues,
                    gardenValues,
                    countBedrooms,
                    kitchenValues,
                    typeApartments,
                    countBathrooms,
                    conditionValues,
                    orientationValues
                }
            },
            configuration: {
                object: {
                    typeApartmentsSell,
                    poolValues: poolValuesConf,
                    lifestyles: configLifestyles,
                    floorValues: floorValuesConf,
                    viewsValues: viewsValuesConf,
                    garageValues: garageValuesConf,
                    gardenValues: gardenValuesConf,
                    kitchenValues: kitchenValuesConf,
                    countBedrooms: configCountBedrooms,
                    countBathrooms: configCountBathrooms,
                    conditionValues: conditionValuesConf,
                    orientationValues: orientationValuesConf
                }
            },
        } = this.props;
        const {easyFurnitureValues} = this.state;

        return (
            <div className="filters_block clearfix vertical-format buy">
                {!empty(i18n) && <div
                    className="filters_accord"
                    onMouseLeave={this.clearActiveAccord}
                    ref={ref => {
                        this.filtersAccord = ref;
                    }}
                >
                    <FiltersAccordItem
                        elements={typeApartmentsSell}
                        elementsForChecked={typeApartments}
                        title={i18n['search.typeApartmentsRental']}
                        elemOnClick={this.handleTypeApartmentsCheck}
                        isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.TYPE_APARTMENT}
                        headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.TYPE_APARTMENT)}
                    />

                    <FiltersAccordItem
                        elements={configLifestyles}
                        elementsForChecked={lifestyles}
                        title={i18n['search.lifestyle']}
                        elemOnClick={this.handleLifeStylesCheck}
                        isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.LIFESTYLE}
                        headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.LIFESTYLE)}
                    />

                    <FiltersAccordItem
                        title="Бассейн"
                        elements={poolValuesConf}
                        elementsForChecked={poolValues}
                        elemOnClick={this.handlePoolValuesCheck}
                        isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.POOL}
                        headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.POOL)}
                    />

                    <FiltersAccordItem
                        title="Гараж"
                        elements={garageValuesConf}
                        elementsForChecked={garageValues}
                        elemOnClick={this.handleGarageValuesCheck}
                        isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.GARAGE}
                        headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.GARAGE)}
                    />

                    <FiltersAccordItem
                        title="Сад"
                        elements={gardenValuesConf}
                        elementsForChecked={gardenValues}
                        elemOnClick={this.handleGardenValuesCheck}
                        isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.GARDEN}
                        headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.GARDEN)}
                    />

                    <FiltersAccordItem
                        title="Этаж"
                        elements={floorValuesConf}
                        elementsForChecked={floorValues}
                        elemOnClick={this.handleFloorValuesCheck}
                        isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.FLOOR}
                        headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.FLOOR)}
                    />

                    <div className="tablet_box_sidebar">
                        <div className="center">
                            <a
                                href=""
                                onClick={this.toggleIsShowAllFilters}
                                className={isShowAllFilters ?
                                    'btn transparent all_filters opened' :
                                    'btn transparent all_filters'}
                            >
                                <span>{i18n['search.allFilters']}</span>
                                <p>{i18n['search.hideFilters']}</p>
                            </a>
                        </div>
                    </div>
                </div>}

                <div className="other_filter">
                    <div className="price">

                        <div className="filter-line range-line">
                            <div className="price-box">
                                <span>{`${i18n['search.price']}, ${this.props.currency}:`}</span>
                                <div className="filter_mask clearfix">
                                    <div className="filter-block-slidefilter">
                                        <input
                                            name="minPrice"
                                            value={this.state.minPrice}
                                            className="minCost filter05-min"
                                            onChange={this.handleMinMaxChange}
                                        />
                                        <input
                                            name="maxPrice"
                                            value={this.state.maxPrice}
                                            className="maxCost filter05-max"
                                            onChange={this.handleMinMaxChange}
                                        />
                                    </div>
                                    <div className="range-container">
                                        <InputRange
                                            minValue={minPriceSettings}
                                            maxValue={maxPriceSettings}
                                            value={this.state.rangePrice}
                                            onChange={::this.handleRangePriceChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="price-box">
                                <span>{`${i18n['search.area']}, ${i18n['objectPage.areaUnit']}:`}</span>
                                <div className="filter_mask clearfix">
                                    <div className="filter-block-slidefilter">
                                        <input
                                            name="minArea"
                                            value={this.state.minArea}
                                            className="minCost filter06-min"
                                            onChange={this.handleMinMaxChange}
                                        />
                                        <input
                                            name="maxArea"
                                            value={this.state.maxArea}
                                            className="maxCost filter06-max"
                                            onChange={this.handleMinMaxChange}
                                        />
                                    </div>
                                    <div className="range-container">
                                        <InputRange
                                            name="rangeArea"
                                            minValue={minAreaSettings}
                                            maxValue={maxAreaSettings}
                                            value={this.state.rangeArea}
                                            onChange={::this.handleRangeAreaChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="filter-line range-line">
                            <div className="price-box">
                                <span>Год постройки</span>
                                <div className="filter_mask clearfix">
                                    <div className="filter-block-slidefilter">
                                        <input
                                            name="minYearOfConstruction"
                                            className="minCost filter06-min"
                                            onChange={this.handleMinMaxChange}
                                            value={this.state.minYearOfConstruction}
                                        />
                                        <input
                                            name="maxYearOfConstruction"
                                            className="maxCost filter06-max"
                                            onChange={this.handleMinMaxChange}
                                            value={this.state.maxYearOfConstruction}
                                        />
                                    </div>
                                    <div className="range-container">
                                        <InputRange
                                            name="rangeYearOfConstruction"
                                            minValue={MIN_YEAR_OF_CONSTRUCTION}
                                            maxValue={MAX_YEAR_OF_CONSTRUCTION}
                                            value={this.state.rangeYearOfConstruction}
                                            onChange={this.handleRangeYearOfConstruction}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {!empty(i18n) && <div
                            className="filter_rent_2_cont"
                            onMouseLeave={this.clearActiveAccord}
                            ref={ref => {
                                this.filterRent2Cont = ref;
                            }}
                        >
                            <FiltersAccordItem
                                isCountElements={true}
                                elements={configCountBedrooms}
                                countForChecked={countBedrooms}
                                title={i18n['search.countBedrooms']}
                                elemOnClick={this.handleCountBedroomsCheck}
                                isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.COUNT_BEDROOMS}
                                headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.COUNT_BEDROOMS)}
                            />

                            <FiltersAccordItem
                                isCountElements={true}
                                elements={configCountBathrooms}
                                countForChecked={countBathrooms}
                                title={i18n['search.countBathrooms']}
                                elemOnClick={this.handleCountBathroomsCheck}
                                isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.COUNT_BATHROOMS}
                                headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.COUNT_BATHROOMS)}
                            />

                            <label className="checkbox renta_2_h">
                                <input
                                    type="checkbox"
                                    onChange={this.handleOurExclusiveCheck}
                                    checked={this.props.requestParams.rangeTypeValues.includes(ObjectConst.RANGE_TYPE.EXCLUSIVE)}
                                />
                                <span>{i18n['search.ourExclusive']}</span>
                            </label>

                            <label className="checkbox">
                                <input
                                    type="checkbox"
                                    onChange={this.handleNewTypeCheck}
                                    checked={this.props.requestParams.newTypeValues.includes(ObjectConst.NEW_TYPE.NEW)}
                                />
                                <span>Новые</span>
                            </label>
                        </div>}
                        <label className="main-search">
                            {this.props.configuration.isGoogleApiInit && <Autocomplete
                                className="text-field"
                                placeholder={i18n['search.autocompletePlaceholder']}
                                types={[]}
                                ref={autocomplete => {
                                    this.addressAutocomplete = autocomplete;
                                }}
                                onPlaceSelected={place => {
                                    ::this.handleAddressChange(place);
                                }}
                            />}
                        </label>

                        <div className="filter-line rn-buttons">
                            <div
                                onClick={this.toggleIsShowAdvancedSearch}
                                className={classnames('more_custom', {
                                    'active': isShowAdvancedSearch
                                })}
                            >
                                <span>
                                    {isShowAdvancedSearch ? i18n['search.hideFilters'] : i18n['search.advancedSearch']}
                                </span>
                            </div>
                            <button onClick={::this.handleFindClick} className="btn">
                                {i18n['search.find']}
                            </button>

                            <SearchForMap />
                        </div>

                        {isShowAdvancedSearch && <div
                            className="more_filter"
                            onMouseLeave={this.clearActiveAccord}
                            ref={ref => {
                                this.moreFilter = ref;
                            }}
                        >
                            <FiltersAccordItem
                                title="Ориентация"
                                elements={orientationValuesConf}
                                elementsForChecked={orientationValues}
                                elemOnClick={this.handleOrientationValuesCheck}
                                isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.ORIENTATION}
                                headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.ORIENTATION)}
                            />

                            <FiltersAccordItem
                                title="Виды"
                                elements={viewsValuesConf}
                                elementsForChecked={viewsValues}
                                elemOnClick={this.handleViewsValuesCheck}
                                isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.VIEWS}
                                headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.VIEWS)}
                            />

                            <FiltersAccordItem
                                title="Состояние"
                                elements={conditionValuesConf}
                                elementsForChecked={conditionValues}
                                elemOnClick={this.handleConditionValuesCheck}
                                isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.CONDITION}
                                headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.CONDITION)}
                            />

{/*                            <FiltersAccordItem
                                title="Мебель"
                                elements={this.getEasyFurnitureValues()}
                                elementsForChecked={easyFurnitureValues}
                                elemOnClick={this.handleEasyFurnitureValuesCheck}
                                isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.EASE_FURNITURE}
                                headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.EASE_FURNITURE)}
                            />*/}

                            <FiltersAccordItem
                                title="Кухня"
                                elements={kitchenValuesConf}
                                elementsForChecked={kitchenValues}
                                elemOnClick={this.handleKitchenValuesCheck}
                                isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.KITCHEN}
                                headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.KITCHEN)}
                            />
                        </div>}
                    </div>
                </div>
                <div className="mobile_box">
                    <div className="box-top">
                        <a
                            href=""
                            onClick={this.toggleIsShowAllFilters}
                            className={isShowAllFilters ?
                                'btn transparent all_filters opened' :
                                'btn transparent all_filters'}
                        >
                            <span>{i18n['search.allFilters']}</span>
                            <p>{i18n['search.hideFilters']}</p>
                        </a>
                    </div>
                    <div className="box-bottom">
                        <SearchForMap />
                        <button onClick={::this.handleFindClick} className="btn">
                            {i18n['search.find']}
                        </button>
                    </div>
                </div>
                <div
                    className={classnames('open_filters clearfix', {
                        'opened': isShowAllFilters
                    })}
                >
                    {!empty(i18n) && <div
                        className="filters_accord"
                        onMouseLeave={this.clearActiveAccord}
                        ref={ref => {
                            this.filtersAccord2 = ref;
                        }}
                    >
                        <FiltersAccordItem
                            elements={typeApartmentsSell}
                            elementsForChecked={typeApartments}
                            title={i18n['search.typeApartmentsRental']}
                            elemOnClick={this.handleTypeApartmentsCheck}
                            isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.TYPE_APARTMENT}
                            headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.TYPE_APARTMENT)}
                        />

                        <FiltersAccordItem
                            elements={configLifestyles}
                            elementsForChecked={lifestyles}
                            title={i18n['search.lifestyle']}
                            elemOnClick={this.handleLifeStylesCheck}
                            isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.LIFESTYLE}
                            headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.LIFESTYLE)}
                        />

                        <FiltersAccordItem
                            title="Бассейн"
                            elements={poolValuesConf}
                            elementsForChecked={poolValues}
                            elemOnClick={this.handlePoolValuesCheck}
                            isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.POOL}
                            headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.POOL)}
                        />

                        <FiltersAccordItem
                            title="Гараж"
                            elements={garageValuesConf}
                            elementsForChecked={garageValues}
                            elemOnClick={this.handleGarageValuesCheck}
                            isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.GARAGE}
                            headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.GARAGE)}
                        />

                        <FiltersAccordItem
                            title="Сад"
                            elements={gardenValuesConf}
                            elementsForChecked={gardenValues}
                            elemOnClick={this.handleGardenValuesCheck}
                            isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.GARDEN}
                            headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.GARDEN)}
                        />

                        <FiltersAccordItem
                            title="Этаж"
                            elements={floorValuesConf}
                            elementsForChecked={floorValues}
                            elemOnClick={this.handleFloorValuesCheck}
                            isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.FLOOR}
                            headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.FLOOR)}
                        />
                    </div>}

                    <div className="other_filter">
                        <div className="filter-line range-line">
                            <div className="price-box">
                                <span>{`${i18n['search.price']}, ${this.props.currency}:`}</span>
                                <div className="filter_mask clearfix">
                                    <div className="filter-block-slidefilter">
                                        <input
                                            name="minPrice"
                                            value={this.state.minPrice}
                                            className="minCost filter05-min"
                                            onChange={this.handleMinMaxChange}
                                        />
                                        <input
                                            name="maxPrice"
                                            value={this.state.maxPrice}
                                            className="maxCost filter05-max"
                                            onChange={this.handleMinMaxChange}
                                        />
                                    </div>
                                    <div className="range-container">
                                        <InputRange
                                            minValue={minPriceSettings}
                                            maxValue={maxPriceSettings}
                                            value={this.state.rangePrice}
                                            onChange={::this.handleRangePriceChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="price-box">
                                <span>{`${i18n['search.area']}, ${i18n['objectPage.areaUnit']}:`}</span>
                                <div className="filter_mask clearfix">
                                    <div className="filter-block-slidefilter">
                                        <input
                                            name="minArea"
                                            value={this.state.minArea}
                                            className="minCost filter06-min"
                                            onChange={this.handleMinMaxChange}
                                        />
                                        <input
                                            name="maxArea"
                                            value={this.state.maxArea}
                                            className="maxCost filter06-max"
                                            onChange={this.handleMinMaxChange}
                                        />
                                    </div>
                                    <div className="range-container">
                                        <InputRange
                                            name="rangeArea"
                                            minValue={minAreaSettings}
                                            maxValue={maxAreaSettings}
                                            value={this.state.rangeArea}
                                            onChange={::this.handleRangeAreaChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="price-box">
                                <span>Год постройки</span>
                                <div className="filter_mask clearfix">
                                    <div className="filter-block-slidefilter">
                                        <input
                                            name="minYearOfConstruction"
                                            className="minCost filter06-min"
                                            onChange={this.handleMinMaxChange}
                                            value={this.state.minYearOfConstruction}
                                        />
                                        <input
                                            name="maxYearOfConstruction"
                                            className="maxCost filter06-max"
                                            onChange={this.handleMinMaxChange}
                                            value={this.state.maxYearOfConstruction}
                                        />
                                    </div>
                                    <div className="range-container">
                                        <InputRange
                                            name="rangeYearOfConstruction"
                                            minValue={MIN_YEAR_OF_CONSTRUCTION}
                                            maxValue={MAX_YEAR_OF_CONSTRUCTION}
                                            value={this.state.rangeYearOfConstruction}
                                            onChange={this.handleRangeYearOfConstruction}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex">
                            <div
                                onClick={this.toggleIsShowAdvancedSearch}
                                className={classnames('more_custom', {
                                    'active': isShowAdvancedSearch
                                })}
                            >
                                <span>
                                    {isShowAdvancedSearch ? i18n['search.hideFilters'] : i18n['search.advancedSearch']}
                                </span>
                            </div>
                        </div>


                        <div className="price">
                            <button onClick={::this.handleFindClick} className="btn">
                                {i18n['search.find']}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

FiltersBlockVertical.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    searchPage: state.searchPage,
    configuration: state.configuration,
    currency: state.configuration.main.currency,
    dateEndMoment: state.searchPage.dateEndMoment,
    requestParams: state.searchPage.requestParams,
    dateStartMoment: state.searchPage.dateStartMoment
});

const mapDispatchToProps = {
    setAddress,
    setMinArea,
    setMaxArea,
    setPlaceId,
    findObjects,
    setMinPrice,
    setMaxPrice,
    setRangeArea,
    setRangePrice,
    setLifestyles,
    setPoolValues,
    setFloorValues,
    setViewsValues,
    setOurExclusive,
    setGarageValues,
    setGardenValues,
    setCountBedrooms,
    setNewTypeValues,
    setKitchenValues,
    setEasyFurniture,
    setTypeApartments,
    setCountBathrooms,
    setConditionValues,
    setIsShowAllFilters,
    setOrientationValues,
    setIsShowAdvancedSearch,
    setMinYearOfConstruction,
    setMaxYearOfConstruction,
    setRangeYearOfConstruction,
    setMapDataFromPlaceAutoComplete
};

export default connect(mapStateToProps, mapDispatchToProps)(FiltersBlockVertical);



// WEBPACK FOOTER //
// ./src/components/Search/Buy/FiltersBlockVertical.js